import React from 'react';

import * as styles from './ErrorBoundary.styles';

export const ErrorPage = () => (
  <div css={styles.errorBoundary}>
    <h1 css={styles.heading}>Something went wrong.</h1>
  </div>
);
